import { ReactNode } from "react";
import FormattedCheckboxGroupInput from "top-component-library/form-inputs/FormattedCheckboxGroupInput";

import { STATUSES } from "../constants";

interface StatusChecklistSectionProps {
  id: string;
  label: string;
  name: string;
  tooltip?: ReactNode;
}

const STATUS_OPTIONS = STATUSES.map((status) => ({ label: status.name, value: status.value }));

// A checklist over the fixed order statuses, used for both "Additional Closed Statuses" and
// "Statuses to Chirp For". Selection is stored on the form field `name` as an array of values.
const StatusChecklistSection = ({ id, label, name, tooltip }: StatusChecklistSectionProps) => (
  <FormattedCheckboxGroupInput
    id={id}
    label={label}
    name={name}
    options={STATUS_OPTIONS}
    required={false}
    onChange={() => {}}
    validationMessage=""
  >
    {tooltip && (
      <div className="margin-bottom-2">
        <em>{tooltip}</em>
      </div>
    )}
  </FormattedCheckboxGroupInput>
);

export default StatusChecklistSection;
